/// <reference path="../../../../typings/index.d.ts" />

module Meevo.UpdateSignatureTitle {
    "use strict";

    // AB#135510 (D.3/D.4/D.6): AngularJS counterpart of the Angular 17 MdOversightSetupDialog
    // (Web.Hub client-charts/md-oversight-setup-dialog) for the My Account entry point. Same
    // fields, same endpoint, same server-side MdOversightValidator - but opens prefilled and
    // saves as "Update" with no approval attached.
    export class UpdateSignatureTitleController {
        static $inject = ["$mdDialog", "meevo.components.common.IdentityService", "meevo.components.common.DataService", "meevo.components.busy.BusyService"];

        title: string = "";
        signatureImage: string = null;          // <meevo-signature ng-model>; Clear sets it to ''
        padHasDrawing: boolean = false;          // <meevo-signature has-content>; true after a stroke
        captureSignature: () => string = null;   // <meevo-signature capture-fn>
        loading: boolean = true;
        saving: boolean = false;
        errorKey: string = null;

        // The image exactly as loaded. Sent back untouched when the pad was never drawn on, so a
        // Title-only edit isn't audited as a signature change (toDataURL never byte-matches it).
        private loadedSignature: string = null;
        private employeeId: string;

        constructor(private $mdDialog: angular.material.IDialogService,
            identityService: Meevo.Components.Common.IIdentityService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private busyService: Meevo.Components.Busy.IBusyService) {
            // String(): IIdentity types userId as Meevo.Guid; a Guid object would serialize as {"guid":...}.
            this.employeeId = String(identityService.current().userId);
            this.load();
        }

        get hasSignature(): boolean {
            return this.padHasDrawing || !!this.signatureImage;
        }

        get canUpdate(): boolean {
            return !this.loading && !this.saving && !!(this.title && this.title.trim()) && this.hasSignature;
        }

        update(): void {
            if (!this.canUpdate) {
                return;
            }

            this.saving = true;
            this.errorKey = null;

            this.dataService.customMethodData("api/Employee/MdOversight", "POST", {
                employeeId: this.employeeId,
                title: this.title.trim(),
                signatureImage: this.padHasDrawing ? this.captureSignature() : this.loadedSignature
            }).then(
                () => this.$mdDialog.hide(true),
                () => {
                    this.saving = false;
                    this.errorKey = "MESSAGE_MD_OVERSIGHT_SAVE_FAILED";
                });
        }

        close(): void {
            this.$mdDialog.hide(false);
        }

        // The pad stays disabled (ng-disabled="vm.loading") and the busy indicator shows until the saved
        // signature arrives: the preload redraws the canvas, which would wipe any stroke drawn before it.
        private load(): void {
            this.busyService.start();
            this.dataService.customMethodData("api/Employee/MdOversight", "GET", {}, { employeeId: this.employeeId }).then(
                (result: any) => {
                    this.title = result.data.title || "";
                    this.signatureImage = result.data.signatureImage || null;
                    this.loadedSignature = this.signatureImage;
                    // A saved signature is preloaded onto the pad, wiping anything drawn before it; without
                    // this reset, Update would capture a redrawn copy of the old one and audit it as changed.
                    if (this.signatureImage) {
                        this.padHasDrawing = false;
                    }
                },
                () => {
                    // Prefill is a convenience (same stance as MdOversightSetupDialog.loadExisting) -
                    // the user can still enter both values fresh.
                    this.errorKey = "MESSAGE_MD_OVERSIGHT_LOAD_FAILED";
                })
                .finally(() => {
                    this.loading = false;
                    this.busyService.stop();
                });
        }
    }

    angular.module("meevo")
        .controller("meevo.updateSignatureTitle.UpdateSignatureTitleController", UpdateSignatureTitleController);
}
